// extracted by mini-css-extract-plugin
module.exports = {"desktop":"min-width: 75em","login":"LoggedOutActions_login__kBrlU","registration":"LoggedOutActions_registration__4SDla"};